import Vue from "vue";

export class CookieService {
  constructor() { }

  setBoolean(componentName, cookieName, cookieValue) {
    Vue.prototype.$cookie.set(cookieName + "::" + componentName, String(cookieValue));
  }

  setString(componentName, cookieName, cookieValue) {
    Vue.prototype.$cookie.set(cookieName + "::" + componentName, cookieValue);
  }

  getCookieBoolean(componentName, cookieName, defaultValue) {
    const strVal = Vue.prototype.$cookie.get(cookieName + "::" + componentName);
    if (strVal) {
      return strVal === "true";
    } else {
      return defaultValue;
    }
  }

  getCookieString(componentName, cookieName) {
    const cookieValue = Vue.prototype.$cookie.get(cookieName + "::" + componentName);
    if (cookieValue === "null" || cookieValue === "undefined") {
      return null;
    }
    return cookieValue;
  }
}